import FontType from '@app/store/FontType';

/**
 * @description - CSS @font-face에 정의되어 있는 font-family를 반환합니다.
 * @param {string} type - 폰트 종류
 */
export default function getFontFaceFontFamily(type) {
  if (!type || typeof type !== 'string') throw new TypeError();

  // 다국어 지원이 필요할 경우 Subset을 이용하던 기존의 시스템에서 변경이 필요합니다.
  const map = {
    [FontType.NOTO_SANS]: 'Noto Sans Text Field',
    [FontType.NOTO_SERIF]: 'Noto Serif Text Field',
  };

  const fontFamily = map[type];
  if (!fontFamily) throw new Error('Matched font-family not exist');

  return fontFamily;
}
